const __WEBPACK_NAMESPACE_OBJECT__ = require("chrome-remote-interface");